import { useUnit } from "effector-react";

import { $app } from "../model/app";

export const useApp = () => {
  const { isInitialized } = useUnit($app);
  return { isInitialized };
};
